import { useEffect, useState } from "react";
import { SimpleModal } from "src/app/components";
import { IActionsModal } from "src/app/types/actionsModal";

export interface IDisableWithConfirmationContainer {
    handleClose?: () => {};
    disableWithConfirmationHandler: (entity: any) => Promise<any>;
    toggleActiveHandler: () => Promise<any>;
    entity?: any;
    updateGridOnSave?: (object: any, isNew: boolean) => void;
}

const DisableWithConfirmationContainer = (props: IActionsModal<any>) => {
    const {
        handleClose = () => {},
        disableWithConfirmationHandler,
        toggleActiveHandler,
        entity,
    } = props;

    const [loading, setLoading] = useState(true);
    const [data, setData] = useState<Array<{ total: string }>>([]);
    useEffect(() => {
        if (disableWithConfirmationHandler)
            disableWithConfirmationHandler(entity)
                .then((res) => setData(res))
                .finally(() => setLoading(false));
    }, []);
    return (
        <SimpleModal
            entityName={`Disable ${entity.name}`}
            handleClose={handleClose}
            buttonConfirmationAction={() => {
                if (toggleActiveHandler) toggleActiveHandler();
                handleClose();
            }}
            buttonConfirmationLabel="Disable"
            disableConfirmation={parseInt(data[0]?.total, 10) > 0}
            loading={loading}
            formId=""
            showModal={true}
            modalProps={{ size: "sm" }}
        >
            <>
                {!loading && (
                    <>
                        <span>total data depended : {parseInt(data[0]?.total || "0", 10)}</span>
                        <div
                            className="d-grid w-100"
                            style={{
                                gridTemplateColumns: "1fr 1fr 1fr",
                                maxHeight: "250px",
                                overflowY: "auto",
                            }}
                        >
                            {data?.map((el: any, i) => (
                                <span key={i}> </span>
                            ))}
                        </div>
                    </>
                )}
            </>
        </SimpleModal>
    );
};

export default DisableWithConfirmationContainer;
